import { MdSettings as SettingsIcon } from 'react-icons/md';

export default SettingsIcon;
